<template>
  <div class="container">
    <div id="header">
      <div class="flex flex-row-left  margin-top-20 ">
        <div class="flex-item-left">
          <el-form :inline="true" :model="formInline" class="demo-form-inline ">
            <!--          <div class="flex flex-row-left flex-item-center margin-right-20">-->
            <el-form-item label="订单渠道">
              <el-select
                  @change="getSalePlatform"
                  style="width:150px"
                  v-model="formInline.salePlatform"
                  clearable
                  placeholder="请选择订单渠道"
              >
                <el-option
                    v-for="item in salePlatformList"
                    :key="item.platformCNName"
                    :label="item.platformCNName"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="销售订单号">
              <el-input style="width:200px" v-model="formInline.saleOrder" placeholder="销售订单号" clearable />
            </el-form-item>
            <el-form-item label="产品相关">
              <el-input style="width:200px" v-model="formInline.materialNo" placeholder="产品SKU,名称,序列号" clearable />
            </el-form-item>
            <!--          </div>
                      <div class="flex flex-row-left flex-item-center">-->
            <el-form-item label="激活时间">
              <el-date-picker
                  value-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  v-model="formInline.startMonth"
                  type="date"
                  placeholder="激活时间"
                  clearable
              />
              -
              <el-date-picker
                  value-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  v-model="formInline.endMonth"
                  type="date"
                  placeholder="激活时间"
                  clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <!--          </div>-->
          </el-form>
        </div>

      </div>
      <div class="flex flex-row-between flex-item-center margin-20-0">
        <div class="flex flex-row-left flex-item-center ">
          <div class="margin-right-20"><el-button type="info" >保内:{{inDate}}</el-button></div>
          <div class="margin-0-20"><el-button type="primary" >保外:{{outDate}}</el-button></div>
          <div class="margin-0-20"><el-button type="success" >报修:{{repair}}</el-button></div>
          <div class="margin-0-20"><el-button type="warning" >延保:0</el-button></div>
          <div class="margin-left-20"><el-button type="danger" >换新:0</el-button></div>
        </div>
        <!--      <div>-->
        <!--        <el-button type="primary" @click="openEidt" >新建设备激活</el-button>-->
        <!--      </div>-->
      </div>
    </div>
    <div class="margin-20-0">
<!--  :max-height="tableHeight"    -->
      <div class="">
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
        >
          <el-table-column

              label="订单渠道"
              min-width="80"
              prop="salePlatform"
          ></el-table-column>
          <el-table-column

              label="订单编码"
              min-width="100"
              prop="saleOrder"
          ></el-table-column>
          <el-table-column
              label="店铺名称"
              min-width="100"
              prop="shopName"
          ></el-table-column>
          <el-table-column
              label="用户信息"
              min-width="100"
              prop="userEmail"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="materialNo"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="materialName"
          ></el-table-column>
          <el-table-column
              label="设备序列码"
              min-width="120"
              prop="materialSn"
          >
            <template #default="scope">
              <div v-for="(item,index) in scope.row.materialSn" :key="index">
                {{item}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="发货时间"
              min-width="80"
              prop="maErpSaleDate"
          ></el-table-column>
          <el-table-column
              label="激活时间"
              min-width="80"
              prop="activeDate"
          ></el-table-column>
          <el-table-column
              label="过保时间"
              min-width="80"
              prop="OverDate"
          ></el-table-column>
          <el-table-column
              sortable
              label="售后次数"
              min-width="80"
              prop="afterTimes"
          ></el-table-column>
          <el-table-column
              sortable
              label="换机次数"
              min-width="80"
              prop="replacement"
          ></el-table-column>
          <el-table-column
              label="换机时间"
              min-width="140"
              prop="replacementDate"
          >
            <template #default="scope">
              <div v-for="(item,index) in scope.row.replacementDate" :key="index">
                {{item}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="审核状态"
              min-width="50"
              prop="addServices"
          >
            <template #default="scope">
              <span v-if="scope.row.activeStatus==0" >待审核</span>
              <span v-else-if="scope.row.activeStatus==1" >已激活</span>
              <span v-else >订单存疑</span>
            </template>
          </el-table-column>
          <el-table-column
              label="附加服务"
              min-width="80"
              prop="addServices"
          ></el-table-column>
          <el-table-column
              label="操作"
              min-width="80"
              prop="addServices"
          >
            <template #default="scope">
              <el-button link type="primary" size="small" @click="handleClick(scope.row)">售后详情</el-button>
              <el-button link type="primary" size="small" @click="check(scope.row)">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <addActiveSale ref="addActiveSale"  @closeEdit="close" ></addActiveSale>
    <activeSaleInfo ref="activeSaleInfo"  @closeEdit="close" ></activeSaleInfo>
  </div>
</template>
<script>
import {
  ElForm, ElFormItem, ElButton, ElInput, ElDatePicker, ElTable,
  ElTableColumn, ElPagination, ElSelect, ElOption
} from "element-plus";
import {afterActive} from "@/utils/api";
import addActiveSale from "@/components/addActiveSale.vue";
import activeSaleInfo from "@/components/activeSaleInfo.vue";
import {getLocalPlatform} from "../../../public/js";

import dynamicHeightMixin from "@/../public/js/dynamicHeightMixin"
export default {
  name: "activeSale",
  components: {
    activeSaleInfo,
    ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,ElSelect, ElOption,
    ElTableColumn,ElPagination,addActiveSale
  },
  mixins:[dynamicHeightMixin],
  data(){
    return{
      formInline:{},
      tableData:[],
      order:"",
      salePlatformList:[],
      inDate:0,
      outDate:0,
      repair:0,
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      curData:{}
    }
  },
  beforeMount(){
    this.getAll()
    getLocalPlatform().then(res => {
      this.salePlatformList = res
    })
  },
  methods:{
    getSalePlatform(value){
      if(!value){
        this.formInline.salePlatform = "";
        this.formInline.salePlatformName = "";
        return
      }
      let indexList = this.salePlatformList.filter((item)=>{
        return item.id == value
      });
      this.formInline.salePlatform = indexList[0].id;
      this.formInline.salePlatformName = indexList[0].platformCNName;
    },
    getAll(){
      //
      afterActive({isActive:false,...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage,orders:this.order} ).then((res)=>{
        this.tableData = res.Data.data
        this.pageTotal = res.Data.count
        this.inDate = res.Data.in_date
        this.outDate = res.Data.out_date
        this.repair = res.Data.repair
      }).catch((err)=>{
        console.log(err)
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getAll();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getAll();
    },
    onSubmit(){
      this.PageNumber = 1
      this.getAll();
    },
    handleSortChange(value){
      console.log(value)
      let order = ''
      let key = value.prop
      if(value.order=='descending'){
        order = 'desc'
        this.order = key+' '+order
      }else if(value.order=='ascending'){
        order = 'asc'
        this.order = key+' '+order
      }else {
        this.order = ''
      }
      this.getAll()
    },
    close(){
      this.getAll()
    },
    openEidt(){
      this.$refs.addActiveSale.open({})
    },
    check(data){
      this.curData = data
      this.$refs.addActiveSale.open(data)
    },
    handleClick(row){
      console.log(row)
      this.$refs.activeSaleInfo.open(row)
    },
  }
}
</script>
<style scoped>
.container{
  width: 94%;
  margin:0 auto;
}
::v-deep .container .el-form-item{
  margin-bottom:0!important;
  margin: 0 10px;
  --font-size: 14px;
  margin-bottom: 18px;
}
::v-deep .el-button+.el-button{
  margin-left: 0 !important;
}
</style>